import Image from 'next/image'
import Wrapper from '../shared/Wrapper'
import PhoneDistractionImage from './assets/phone-distraction.png'

export default function PhoneDistraction(): JSX.Element {
  return (
    <div className="py-10">
      <Wrapper className="text-white">
        <div className="w-full max-w-2xl mx-auto text-center">
          <h1 className="text-3xl mb-2 font-semibold">
            Does your phone distract you?
          </h1>
          <p className="text-white text-opacity-40">
            If you pick up your phone while you’re working, your Coach will
            nudge you back on track.
          </p>
        </div>

        <div className="my-16 px-8 w-full max-w-5xl mx-auto">
          <Image
            src={PhoneDistractionImage}
            alt="focus app stopping a cell phone distraction"
          />
        </div>
      </Wrapper>
    </div>
  )
}
